/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-12 11:57:03
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-21 15:38:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/Components/index.ts
 */
export { default as FileList } from './FileList';
export { default as Card } from './Card';
